export const STATUS_OPTIONS = [
  { value: 'GEPLANT', label: 'Geplant' },
  { value: 'LAUFEND', label: 'Laufend' },
  { value: 'ERFOLGREICH', label: 'Erledigt' },
  { value: 'FEHLER', label: 'Fehler' },
  { value: 'WARTEND', label: 'Wartend' },
  { value: 'GELOESCHT', label: 'Gelöscht' },
  { value: 'PAUSIERT', label: 'Pausiert' },
  { value: 'ZURUECKGESTELLT', label: 'Zurückgestellt' },
];

export const MAIN_STATUS_FILTER_OPTIONS = STATUS_OPTIONS.filter(
  (option) => option.value !== 'GELOESCHT' && option.value !== 'ERFOLGREICH',
);

export const ARCHIV_STATUS_FILTER_OPTIONS = STATUS_OPTIONS.filter(
  (option) => option.value === 'GELOESCHT' || option.value === 'ERFOLGREICH',
);
